import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import UIButtonIcon from '../../components/UI/UIButtonIcon'
import { COLOR_WHITE } from '../../lib/colors'
import { IconPlus } from '../Icon'
import { toast } from 'react-toastify'
import AddMoreTimePopup from '../../modal/AddMoreTimePopup'

const WidgetLiveTimeControl = ({ time, onAddMoreTime, dynamicStyle }) => {
  const handleAddMoreTime = () => {
    toast(<AddMoreTimePopup onContinue={onAddMoreTime} />, {
      autoClose: false,
      closeOnClick: false,
      draggable: true,
      closeButton: false,
      className: 'toast-container',
      toastClassName: 'toast',
    })
  }

  return (
    <div className={css(styles.container, dynamicStyle && dynamicStyle)}>
      <p>{time}</p>
      <UIButtonIcon onClick={handleAddMoreTime}>
        <IconPlus color={COLOR_WHITE} />
      </UIButtonIcon>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '2em',
    color: COLOR_WHITE,
  },
})

WidgetLiveTimeControl.propTypes = {
  time: PropTypes.string,
  onAddMoreTime: PropTypes.func,
  closeToast: PropTypes.func,
  dynamicStyle: PropTypes.object,
}

export default WidgetLiveTimeControl
